const PRODUCTION = false
const PRODUCTION_HTTPS = false

const API_LOGIN = '/login'
const API_REGISTER = '/register'
const API_IMAGE = '/image'
const API_VIDEO = '/video'
const API_ALIVE = '/alive'

const LOCAL_HOST = '127.0.0.1'
const PRODUCTION_HOST = '81.169.224.226'
const API_LOCAL_HOST = '81.169.224.226'
const API_PRODUCTION_HOST = '81.169.224.226'

const LOCAL_PORT = '3000'
const PRODUCTION_PORT = '8080'
const API_LOCAL_PORT = '443'
const API_PRODUCTION_PORT = '443'

const HTTP = 'http://'
const HTTPS = 'https://'

const EDITOR = 'editor'

const config = {
	PRODUCTION,
	PRODUCTION_HTTPS,
	API_LOGIN,
	API_REGISTER,
	API_IMAGE,
	API_VIDEO,
	API_ALIVE,
	LOCAL_HOST,
	PRODUCTION_HOST,
	API_LOCAL_HOST,
	API_PRODUCTION_HOST,
	LOCAL_PORT,
	PRODUCTION_PORT,
	API_LOCAL_PORT,
	API_PRODUCTION_PORT,
	HTTP,
	HTTPS,
	EDITOR
}

export default config